import type { Config } from 'isomorphic-dompurify';

export const purifyConfig: Config = {
  ALLOWED_TAGS: [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'br',
    'p',
    'a',
    'img',
    'picture',
    'ul',
    'ol',
    'li',
    'code',
    'pre',
    'blockquote',
    'strong',
    'em',
    'video',
    'source',
    'details',
    'summary',
    'svg',
    'path',
    'span',
    'table',
    'thead',
    'tbody',
    'tr',
    'th',
    'td',
    'b',
    'i',
    'hr',
    'kbd',
    'mark',
    'samp',
    'sub',
    'sup',
  ],
  ALLOWED_ATTR: [
    'href',
    'src',
    'srcset',
    'sizes',
    'media',
    'preload',
    'alt',
    'class',
    'controls',
    'muted',
    'aria-hidden',
    'height',
    'viewBox',
    'version',
    'width',
    'data-view-component',
    'aria-label',
    'dir',
    'open',
    'data-canonical-src',
    'type',
    'playsinline',
    'autoplay',
    'loop',
    'align',
    'target',
    'rel',
    'd',
    'data-no-image-dialog',
  ],
  ADD_ATTR: ['loading', 'decoding', 'controls'],
  FORBID_TAGS: ['style', 'script'],
  FORBID_ATTR: ['style', 'onerror', 'onload'],
};
